const paths = {
    escarpment: (
        <>
            <path d="M6 46 L26 20 L34 28 L58 28" />
            <path d="M6 52 H58" />
            <path d="M34 40 H58" />
            <path d="M12 46 H30" />
        </>
    ),
    harbour: (
        <>
            <path d="M28 14 H36 L38 44 H26 Z" />
            <path d="M27 22 H37" />
            <path d="M30 14 V8 H34 V14" />
            <path d="M6 50 C12 46 18 54 24 50 C30 46 36 54 42 50 C48 46 54 54 58 50" />
            <path d="M14 44 L22 36 M50 44 L42 36" />
        </>
    ),
    bridge: (
        <>
            <path d="M4 42 H60" />
            <path d="M8 42 C20 18 44 18 56 42" />
            <path d="M18 42 V30 M32 42 V25 M46 42 V30" />
            <path d="M8 50 H56" />
        </>
    ),
    hills: (
        <>
            <path d="M4 44 C14 30 22 30 30 40 C38 48 46 44 60 32" />
            <path d="M4 54 C16 44 28 44 38 50 C46 54 54 52 60 46" />
            <circle cx="46" cy="16" r="6" />
        </>
    ),
};

export const MunicipalityMark = ({ mark, className = "h-12 w-12", stroke = "currentColor" }) => (
    <svg
        viewBox="0 0 64 64"
        fill="none"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden="true"
    >
        {paths[mark] || paths.hills}
    </svg>
);
